import { Component, Input, OnInit } from '@angular/core';
import { EaGroup } from '../ea-group.component';

export interface EaGroupOptions {
  class: string;
}

@Component({
    selector: 'ea-groups',
    templateUrl: './ea-groups.component.html',
    styleUrls: ['./ea-groups.component.scss'],
    standalone: false
})
export class EaGroupsComponent implements OnInit {
  @Input() groups: EaGroup[];
  @Input() options: { class: string };
  @Input() clazz: string;
  @Input() context;

  constructor() {}

  ngOnInit() {}
}
